import axios from "axios";
import { BASE_URL } from "./common/api_constants";

const customAxios = axios.create({
  baseURL: BASE_URL,
});

const requestHandler = (request) => {
  const user = localStorage.getItem("Ravimate");
  console.log("🚀 ~ requestHandler ~ user:", user?.token)

  if (user) {
    const userData = JSON.parse(user);
    const token = userData.access_token;
    console.log("🚀 ~ requestHandler ~ token:", token)
    request.headers.Authorization = `Bearer ${token}`;
  }
  return request;
};

const responseHandler = (response) => {
  if (response.status === 401) {
    localStorage.clear();
    window.location.href = "/login";
  }
  return response;
};

const requestErrorHandler = (error) => {
  return Promise.reject(error);
};

const responseErrorHandler = (error) => {
  if (error.response) {
    if (error.response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return Promise.reject(error);
    }
  }
  return Promise.reject(error);
};

customAxios.interceptors.request.use(
  (request) => requestHandler(request),
  (error) => requestErrorHandler(error)
);

customAxios.interceptors.response.use(
  (response) => responseHandler(response),
  responseErrorHandler
);

export default customAxios;
